module.exports = __webpack_public_path__ + "img/u34.513141a9.png";